module.exports = __webpack_public_path__ + "img/home-07-cosmopolitan-cerita-06.2f486b52.jpg";